// [WHY] Datadog parses "?" as a query string, so its own "/?/" placeholder would truncate our paths.
const ID_PLACEHOLDER = ":id"
const TOKEN_MIN_LENGTH = 20

const NUMERIC_ID = /^\d+(\.\w+)?$/
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const ORGANIZATION_ID = /^\d+$/

// Rails signed IDs (e.g. magic links) join payload and digest with "--".
const isToken = (segment) =>
  segment.includes("--") || (segment.length >= TOKEN_MIN_LENGTH && /\d/.test(segment))

const isIdentifier = (segment) =>
  NUMERIC_ID.test(segment) || UUID.test(segment) || isToken(segment)

const scrubSegment = (segment) => (isIdentifier(segment) ? ID_PLACEHOLDER : segment)

const scrubOrganizationSegment = (segment) =>
  ORGANIZATION_ID.test(segment) ? segment : scrubSegment(segment)

// Auth-host routes that nest `:organization_id` under a fixed prefix; see the auth host scope in config/routes.rb.
const ORGANIZATION_PREFIXES = [["saml", "proxy"], ["sso"]]

const startsWith = (segments, prefix) => prefix.every((prefixSegment, index) => segments[index] === prefixSegment)

const organizationSegmentIndex = (segments) =>
  ORGANIZATION_PREFIXES.find((prefix) => startsWith(segments, prefix))?.length ?? 0

// Org-scoped routes put the org ID first (or after a known prefix); it's kept so RUM views can be broken down per customer.
const scrubPath = (pathname) => {
  const segments = pathname.split("/").slice(1)
  const organizationIndex = organizationSegmentIndex(segments)

  const scrubbed = segments.map((segment, index) =>
    index === organizationIndex ? scrubOrganizationSegment(segment) : scrubSegment(segment)
  )
  return "/" + scrubbed.join("/")
}

// Auth URLs can carry SAML/session params and paths can carry record IDs or tokens.
export const scrubRumUrl = (url) => {
  if (!url) return url

  const { origin, pathname } = new URL(url, window.location.origin)
  return origin + scrubPath(pathname)
}
